import { combineReducers } from 'redux'

import devicePolicyReducer, { NAME as devicePolicy } from './devicePolicyReducer.js'
import hardwareReducer, { NAME as hardware } from './hardwareReducer.js'
import messageReducer, { NAME as messages } from './messageReducer'
import modalReducer, { NAME as modal } from './modalReducer.js'
import onboardingReducer, { NAME_SPACE as onboarding } from './onboardingReducer.js'
import resaleReducer, { NAME as resale } from './resaleReducer.js'

export default combineReducers({
  [messages]: messageReducer,
  [onboarding]: onboardingReducer,
  [devicePolicy]: devicePolicyReducer,
  [hardware]: hardwareReducer,
  [modal]: modalReducer,
  [resale]: resaleReducer,
})
